import { formatDateValue, parseIsoDate } from '~/models/dateTime'

/**
 * 清算画面の「詳細」から、 開いた先の入札画面 (スポット入札・時間前入札) へ渡す初期状態
 * (`docs/specs/bidding/jepx-settlement.md` AC-JST-009)。
 *
 * 運ぶのは「どの市場のどの日か」だけで、 開く先のタブやフィルターの初期状態は受け側が決める
 * (`spot-bidding.md` AC-BSP-043 の例外・`intraday-bidding.md` AC-BIN-102 の追記)。
 * location state は履歴に残るので、 読む側は型を信用せず確かめる。
 */
export type SettlementDetailMarket = 'spot' | 'intraday'

export type SettlementDetailLanding = {
  market: SettlementDetailMarket
  /** YYYY-MM-DD */
  date: string
}

export type SettlementDetailLandingState = {
  settlementDetailLanding: SettlementDetailLanding
}

export function toSettlementDetailLandingState(
  landing: SettlementDetailLanding,
): SettlementDetailLandingState {
  return { settlementDetailLanding: landing }
}

/**
 * location state から、 指定した市場の入札画面向けの着地の日を読む。 形が違うもの・別の市場のもの・
 * 暦に無い日付は undefined。
 */
export function readSettlementDetailLandingDate(
  state: unknown,
  market: SettlementDetailMarket,
): Date | undefined {
  if (typeof state !== 'object' || state === null) return undefined
  const landing = (state as Record<string, unknown>).settlementDetailLanding
  if (typeof landing !== 'object' || landing === null) return undefined
  const { market: landingMarket, date } = landing as Record<string, unknown>
  if (landingMarket !== market || typeof date !== 'string') return undefined
  const parsed = parseIsoDate(date)
  // "2026-02-31" のような繰り上がる日付は往復して一致しない。
  return parsed !== undefined && formatDateValue(parsed) === date
    ? parsed
    : undefined
}
